import {
  FULFILLMENT_STATUSES,
  IntegrationService,
  ORDER_METHODS,
  ORDER_PAYMENT_STATUSES,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../../services/exports/Constants';
import { action_create_dummy_order, action_launch_orders_portal_app } from '../../../../../../views/sales/orders';

export default {
  title: 'Comenzi',
  buttons: {
    actions: 'Acțiuni',
    [action_create_dummy_order]: 'Creați comandă de test',
    [action_launch_orders_portal_app]: 'Lansați portalul de comenzi',
    show_order_details: 'Afișați detaliile comenzii',
    track_order: 'Urmăriți comanda',
    update_dropoff_time: 'Actualizați ora de livrare',
    download_receipt: 'Descărcați chitanța',
    open_payment_page: 'Deschideți pagina de plată',
  },
  form: {
    customer_details: {
      placeholder: 'Introduceți numele sau numărul de telefon al clientului',
    },
    amount_min: {
      placeholder: 'Sumă minimă',
    },
    amount_max: {
      placeholder: 'Sumă maximă',
    },
    utm_source: {
      placeholder: 'Introduceți sursa utm',
    },
    utm_medium: {
      placeholder: 'Introduceți mediul utm',
    },
    utm_campaign: {
      placeholder: 'Introduceți campania utm',
    },
    utm_advertisement_id: {
      placeholder: 'Introduceți id-ul reclamei utm',
    },
  },
  labels: {
    no_orders: 'Nicio comandă încă',
    total_orders: 'Total comenzi',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Ridicare',
    [ORDER_METHODS.delivery]: 'Livrare',
    [ORDER_METHODS.room_service]: {
      [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Room service',
      [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Serviciu la masă',
    },
  },
  payment_statuses: {
    [ORDER_PAYMENT_STATUSES.pending]: 'În așteptare',
    [ORDER_PAYMENT_STATUSES.paid]: 'Plătit',
    [ORDER_PAYMENT_STATUSES.partially_refunded]: 'Parțial rambursat',
    [ORDER_PAYMENT_STATUSES.refunded]: 'Rambursat',
  },
  fulfillment_statuses: {
    default: {
      [FULFILLMENT_STATUSES.created]: 'În așteptarea aprobării',
      [FULFILLMENT_STATUSES.reviewed]: 'În așteptarea aprobării',
      [FULFILLMENT_STATUSES.accepted]: 'În lucru',
      [FULFILLMENT_STATUSES.preparing]: 'În lucru',
      [FULFILLMENT_STATUSES.ready]: 'În lucru',
      [FULFILLMENT_STATUSES.on_delivery]: 'În lucru',
      [FULFILLMENT_STATUSES.picked]: 'Finalizat',
      [FULFILLMENT_STATUSES.rejected]: 'Respins',
      null: 'Necunoscut',
      undefined: 'Necunoscut',
    },
  },
  tags: {
    dummy: 'TEST',
    pickup: 'Ridicare',
    internal_delivery: 'Livrare internă',
    external_delivery: 'Livrare externă',
    room_service: 'Room service',
    table_service: 'Serviciu la masă',
    scheduled: 'Programat',
    reward: 'Recompensă',
    mobile: 'Mobil',
    invoice: 'Factură',
    cash: 'Numerar',
    rejected_automatically: 'Respins automat',
    rejected_manually: 'Respins manual',
    call_center: 'Call center',
    [IntegrationService.WinOrder]: 'WINORDER',
    [IntegrationService.ExpertOrder]: 'EXPERT ORDER',
    [IntegrationService.Deliverect]: 'DELIVERECT',
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    tags: 'Etichete',
    order_placed: 'Comandă plasată',
    ready_at: 'Comandă gata',
    customer: 'Client',
    items: 'Articole',
    method: 'Metodă',
    payment_status: 'Status plată',
    fulfillment_status: 'Status',
    total: 'Total',
    utm_source: 'Sursă UTM',
    utm_medium: 'Mediu UTM',
    utm_campaign: 'Campanie UTM',
    utm_advertisement_id: 'Id Reclamă UTM',
  },
  metrics: {
    total_orders: 'Total comenzi',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
    failed_to_create_dummy_order: 'Eroare la crearea comenzii de test',
    dummy_order_created: 'Comanda de test a fost creată',
    failed_to_launch_orders_portal_app: 'Eroare la lansarea portalului de comenzi',
    failed_to_download_receipt: 'Eroare la descărcarea chitanței',
  },
};
